import { render, staticRenderFns } from "./recActLogs.vue?vue&type=template&id=91f1de1a&scoped=true"
import script from "./recActLogs.vue?vue&type=script&lang=js"
export * from "./recActLogs.vue?vue&type=script&lang=js"
import style0 from "./recActLogs.vue?vue&type=style&index=0&id=91f1de1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f1de1a",
  null
  
)

export default component.exports